import { dispatcher } from "@quest/base-core";
import { Wrapper } from "@quest/platform-murka/dist";
import { SlotEventConstantsBehavior } from "@quest/murka-games-behavior-leopard/dist";

export class WrapperController extends Wrapper {
    //Function to reset autoplay in case of insufficient funds
    protected handlingError(evt: any) {
        super.handlingError(evt);
        if (evt.data.code === 509) {
            // error code for insuffient fund
            dispatcher.fireEvent(SlotEventConstantsBehavior.STOP_AUTOPLAY_BEFORE_FEATURE);
        }
    }
}
